import React from 'react';
import './topImageCard.css';
import {Col, Container, Image, Row} from "react-bootstrap";
import {Link} from "react-router-dom";


function TopImageCard({img,title,category,view,href}) {
    return (
        <Col sm={12} md={6} lg={3} className={'mt-4 top-image-card-col'}>
            <Link to={href}>
                <div className={'top-image-card'}>
                    <div className={'image-wrapper'}>
                        <Image src={img}></Image>
                    </div>
                    <h4>{title}</h4>
                    <div className={'top-image-card-footer'}>
                        <p className={'image-right-side'}>{category}</p>
                        <div className={'footer-left-side'}>
                            <i className="fa-regular fa-eye"></i>
                            <p>{view} بازدید</p>
                        </div>
                    </div>
                </div>
            </Link>
        </Col>
    );
}

export default TopImageCard;